<section class="box-wrapper">
    <div class="logo-wrap" (click)="logoClick()">
        <serviceos-ng-logo
            *ngIf="logo$ | async as logo"
            [logoUrl]="logo"
            [brandName]="logoText ? logoText : ''"
        ></serviceos-ng-logo>
    </div>
    <div class="language-section" *ngIf="languages$ | async as languages">
        <ng-container *ngIf="languages && languages.length > 1">
            <div class="language-holder" *ngIf="currentLanguage$ | async as currentLanguage">
                <span class="indicator">
                    <i *ngIf="currentLanguageFlagUrl" [style.background-image]="'url(' + currentLanguageFlagUrl + ')'"></i>
                    <span *ngIf="!currentLanguageFlagUrl">{{ currentLanguage }}</span>
                    <span class="iconarrow"></span>
                </span>
                <div class="selector">
                    <!-- <span class="language-list-title" *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.select_language_title ? moduleAuthTexts.select_language_title : 'Select language' }}</span> -->
                    <ul>
                        <li *ngFor="let item of languages" (click)="onLanguageSelect(item)">
                            <i *ngIf="item.icon_url" [style.background-image]="'url(' + item.icon_url + ')'"></i>
                            {{ item.title }}
                        </li>
                    </ul>
                </div>
            </div>
        </ng-container>
    </div>
</section>
<!-- <serviceos-ng-loader></serviceos-ng-loader> -->
<serviceos-web-mobile-screen></serviceos-web-mobile-screen>